export default __webpack_public_path__ + "static/media/jenis-2.00d26013.png";